define('viewmodels/app/__print',[
        'lodash', 'moment','durandal/system', 'atn/atn',
        'dataSource/logoDataUri', 'jquery',
        'knockout', 'dataSource/oemMessages',
        'pdfGear/generator/docDefinition', 'atn/pdfUtils',
        'pdfGear/localization/labels'
    ],
    function(
        _, moment, system, atn, logoDataUri, $,
        ko, oemMessages, pdfGear, pdfUtils, pdfLabels
    ) {
        'use strict';

        /**
         * generation time to be displated on the generated PDF
         * @type {[type]}
         */
        var time = ko.observable();

        /**
         * observable to check weather graph is being printed or not
         * @type {bool}
         */
        var printing = ko.observable();

        /**
         * Observable to hold the percent of print completed
         * @type {Number}
         */
        var completed = ko.observable(0);

        // changing the value of printing observable on change of percentage complition
        completed.subscribe(function(percent) {
            if (percent < 100) {
                printing(true);
            } else {
                _.delay(printing, 0, false);
            }
        });

        return {
            completed: completed,
            printing: printing,
            printCharts: printCharts
        };

        /**
         * This function is resposible for printing pdf of all the modules
         * @param  {String} title          Title of the pdf
         * @param  {Array} widgets         List of widgets to be printed
         * @param  {String} filename       Name of the file to be printed
         * @return {Deferred.Promise}      Promise for pdf has been generated
         */
        function printCharts(title, widgets, filename) {
            var deferred = $.Deferred(),pdfTemplate, dd;

            var promise = logoDataUri.getCompanyLogoDataUri();

            promise.done(function(){
                time(moment.utc().format([atn.config.dayGeneratedOnFormat,atn.config.timeGeneratedOnFormat,'z'].join('  ')));
                pdfTemplate = {
                    reportTitle: title,
                    logoImage: logoDataUri.companyLogoDataUri(),
                    brandName: atn.config.messages.brandingInfo.fullName,
                    generationDate: {
                        key: pdfLabels.header.pdfGenerationText,
                        value: time()
                    },
                    widgets: widgets
                };

                dd = pdfGear.createDocDefinition(pdfTemplate);
                pdfUtils.downloadPdf(dd, filename, function() {
                    deferred.resolve();
                });
            });

            return deferred.promise();
        }
    });
